export default function clampExpirationDate(date) {
  // If the formatted expiration date is a valid date, we now must clamp
  // it according to the following criteria:
  // First, we subtract 30 days from the date, to allow for the course
  // of the medication to be considered. Then we clamp the adjusted
  // date to the min of that adjusted date or 11 months from now and
  // return the adjusted (clamped) date.
  const fullDateMatch = date.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!fullDateMatch) return null;

  const [, mm, dd, yyyy] = fullDateMatch;
  const parsed = new Date(Number(yyyy), Number(mm) - 1, Number(dd));

  if (isNaN(parsed.getTime())) return null;

  const minus30 = new Date(parsed);
  minus30.setDate(minus30.getDate() - 30);

  const elevenMonthsFromNow = new Date();
  elevenMonthsFromNow.setMonth(elevenMonthsFromNow.getMonth() + 11);

  const clamped = minus30 < elevenMonthsFromNow ? minus30 : elevenMonthsFromNow;

  const cmm = String(clamped.getMonth() + 1).padStart(2, '0');
  const cdd = String(clamped.getDate()).padStart(2, '0');
  const cyyyy = String(clamped.getFullYear());
  return `${cmm}/${cdd}/${cyyyy}`;
}
